import React, { Component } from 'react'
import { bindActionCreators} from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import qs from "qs";
import update from "immutability-helper";
import {Link} from 'react-router-dom';
import _ from "lodash";
import {
    Table,
    Segment,
    Breadcrumb,
    Button,
    Input,
    Label
} from "semantic-ui-react";
import TableFilter from "../utils/tables/TableFilter";
import OrderByHeader from "../utils/tables/OrderByHeader";
import TablePagination from "../utils/tables/TablePagination";
import Dls from "../../lib";
import {
    fetchShipment
} from '../../actions/shipment';
const statusOptions = [
    { key: "Pending", text: "Pending", value: "Pending" },
    { key: "Shipped", text: "Shipped", value: "Shipped" }
];

class ShipmentListPage extends Component {
    constructor() {
        super();
        this.state = {
            routing: {
                params: {
                    type: 'inbound',
                    on_page: 1,
                    per_page: 15,
                    search: '',
                    filters: {
                        status: 'Pending',
                        warehouse_id: 'All'
                    },
                    order_by: {
                        created_at: 'desc'
                    }
                },
                path: ""
            },
            filters: {
                status: [],
                warehouse_id: []
            },
            routeType: ''
        };
    }

    componentDidMount() {
        const { params } = this.props.match;
        this.setQueryParamsFromPath(params.params, params.type);
    }

    componentWillReceiveProps(props) {
        const { params } = props.match;
        this.setQueryParamsFromPath(params.params, params.type);
    }

    setQueryParamsFromPath = (path, shipmentType) => {
        if (this.state.routing.path !== path) {
            const params = qs.parse(path);
            const { filters } = params;
            let defaultStatusFilter = [];
            let defaultWarehouseIdFilter = [];
            if (_.isObject(filters)) {
                if (filters.status) {
                    defaultStatusFilter = filters.status.split(",");
                }
                if (filters.warehouse_id) {
                    defaultWarehouseIdFilter = filters.warehouse_id.split(",");
                }
            }

            this.setState({
                routing: { params, path },
                filters: {
                    status: defaultStatusFilter,
                    warehouse_id: defaultWarehouseIdFilter
                },
                routeType: shipmentType
            }, () => {
                this.fetchRecords();
            });
        }
    };

    fetchRecords = () => {
        const {jwt} = this.props;
        const {params} = this.state.routing;
        this.props.fetchShipment(jwt, qs.stringify(params)).catch(err => {
            Dls.apiErrorAlert(err);
        });;
    };

    runSearch = () => {
        this.setState({
            routing: {
                params: update(this.state.routing.params, {
                    on_page: { $set: 1 }
                })
            }
        }, () => {
            this.routeTo();
        });
    };

    routeTo = () => {
        const {routeType} = this.state;
        if (routeType) {
            this.props.history.push(`/shipments/${routeType}/${qs.stringify(this.state.routing.params)}`);
        } else {
            this.props.history.push("/");
        }
    }

    _onTableHeaderSort = (field, value) => {
        this.setState({
            routing: {
                params: update(this.state.routing.params, {
                    order_by: {
                        [field]: {$set: value}
                    }
                })
            }
        }, () => {
            this.routeTo();
        });
    };

    _handleKeyPress = e => {
        if (e.key === "Enter") {
            this.runSearch();
        }
    };

    _onSearchChange = e => {
        this.setState({
            routing: {
                params: update(this.state.routing.params, {
                    search: { $set: e.target.value }
                })
            }
        });
    };

    _onStatusDropdownSelectChange = (e, data) => {
        const { value } = data;
        this.setState({
            filters: update(this.state.filters, {
                status: { $set: value }
            })
        });
        this.setState({
            routing: update(this.state.routing, {
                params: {
                    filters: {
                        status: {$set: value.join()}
                    }
                }
            })
        })
    };

    _onWarehouseIdDropdownSelectChange = (e,data) => {
        const { value } = data;
        this.setState({
            filters: update(this.state.filters, {
                warehouse_id: { $set: value }
            })
        });
        this.setState({
            routing: update(this.state.routing, {
                params: {
                    filters: {
                        warehouse_id: {$set: value.join()}
                    }
                }
            })
        })
    }

    goToPage = (page) => {
        this.setState({
            routing: {
                params: update(this.state.routing.params, {
                    on_page: { $set: page }
                })
            }
        }, () => {
            this.routeTo();
        });
    }

    getWarehouseName = (warehouseId) => {
        const {warehouses} = this.props;

        let warehouse = warehouses.filter(i => {
            return parseInt(i.value) === parseInt(warehouseId);
        })

        if (!_.isEmpty(warehouse) && warehouse.length === 1) {
            return warehouse[0].text
        } else {
            return "NA"
        }
    }
    
    render() {
        const {list, warehouses} = this.props;
        const {routeType} = this.state;
        let warehousesListWithAll = _.cloneDeep(warehouses);
        warehousesListWithAll.unshift({
            key: 'All',
            text: 'All Warehouses',
            value: 'All'
        });
        return (
            <div>
                <div className="row" style={{ marginBottom: "5px" }}>
                    <div className="col-md-8">
                        <Breadcrumb size="huge">
                            <Breadcrumb.Section>
                                Shipments
                            </Breadcrumb.Section>
                            <Breadcrumb.Divider />
                            <Breadcrumb.Section>
                                <Link
                                    to={`/shipments/${routeType}/${Dls.pagination.shipments(routeType==='receiving' ? 'inbound' : 'outbound')}`}
                                >
                                    {_.upperFirst(routeType)}
                                </Link>
                            </Breadcrumb.Section>
                        </Breadcrumb>
                    </div>
                    <div className="col-md-4">
                    
                    </div>
                </div>
                <div className="row" style={{ marginBottom: "5px" }}>
                    <div className="col-md-12">
                        <Segment>
                            <div className="col-md-12">
                                <Input
                                    placeholder="Search QB ref #, order # or order ref #"
                                    size="mini"
                                    action
                                    onKeyPress={this._handleKeyPress}
                                    onChange={this._onSearchChange}
                                    value={this.state.routing.params.search}
                                    fluid
                                >
                                    <input />
                                    <Button
                                        icon="filter"
                                        onClick={() => {this.runSearch()}}
                                        type="button"
                                        color="pink"
                                    />
                                </Input>
                            </div>
                            <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-4" style={{ marginTop: "5px" }}>
                                    <TableFilter
                                        name="Status"
                                        options={statusOptions}
                                        selectedValues={
                                            this.state.filters.status
                                        }
                                        onDropdownSelectChange={(e, data) => {
                                            this._onStatusDropdownSelectChange(
                                                e,
                                                data
                                            );
                                        }}
                                        placeHolder="Filter by order status"
                                    />
                                </div>
                                <div className="col-md-8" style={{marginTop: "5px"}}>
                                    <TableFilter
                                        name="Warehouse"
                                        options={warehousesListWithAll}
                                        selectedValues={
                                            this.state.filters.warehouse_id
                                        }
                                        onDropdownSelectChange={(e, data) => {
                                            this._onWarehouseIdDropdownSelectChange(
                                                e,
                                                data
                                            );
                                        }}
                                        placeHolder="Filter by warehouses"
                                    />
                                </div>
                            </div>
                            </div>
                        </Segment>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Table compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>
                                        Status
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Warehouse
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        QB Ref #
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        {routeType==='receiving' ? 'Receive From' : 'Ship To'}
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Order #
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Order Ref #
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Courier
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        DS
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <OrderByHeader
                                            headerName='Created On'
                                            currentValue={
                                                this.state.routing.params
                                                    .order_by.created_at
                                                    ? this.state.routing.params
                                                          .order_by.created_at
                                                    : ""
                                            }
                                            field="created_at"
                                            onSortListChange={(
                                                field,
                                                value
                                            ) => {
                                                this._onTableHeaderSort(
                                                    field,
                                                    value
                                                );
                                            }}
                                        />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        View
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {_.isArray(list.data) ? list.data.map(i => {
                                    return <Table.Row key={i.id}>
                                        <Table.Cell>
                                            {i.status === 'Pending' ? <Label color='teal' size='mini'>Pending</Label> : null}
                                            {i.status === 'Shipped' ? <Label color='green' size='mini'>Completed</Label> : null}
                                        </Table.Cell>
                                        <Table.Cell>{this.getWarehouseName(i.warehouse_id)}</Table.Cell>
                                        <Table.Cell>{i.invoice_number}</Table.Cell>
                                        <Table.Cell>
                                            {_.isObject(i.relation_name) ? i.relation_name.company_name : ""}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {_.isObject(i.order) ? i.order.so : ""}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {_.isObject(i.order) ? i.order.reference : ""}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.courier}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.drop_ship ? <Label color='green' size='mini'>DS</Label> : null}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.created_at}
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Link to={`/shipments/${routeType}/${i.id}/view`}>
                                                View
                                            </Link>
                                        </Table.Cell>
                                    </Table.Row>
                                }) : null}
                            </Table.Body>
                        </Table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12" style={{marginTop: '5px'}}>
                        <TablePagination
                            goToPage={(page) => {this.goToPage(page);}}
                            on_page={list.on_page}
                            total_records={list.total_count}
                            per_page={list.per_page} />
                    </div>
                </div>
            </div>
        )
    }
}

ShipmentListPage.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    fetchShipment: PropTypes.func.isRequired,
    list: PropTypes.object.isRequired,
    jwt: PropTypes.string.isRequired,
    warehouses: PropTypes.array.isRequired
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt,
        list: state.shipment.list,
        warehouses: state.system.resources.warehouses
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchShipment
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentListPage)


// WEBPACK FOOTER //
// ./src/components/shipments/ShipmentList.js